import { render, staticRenderFns } from "./MarkdownContent.vue?vue&type=template&id=b33542da&scoped=true"
import script from "./MarkdownContent.vue?vue&type=script&lang=ts"
export * from "./MarkdownContent.vue?vue&type=script&lang=ts"
import style0 from "./MarkdownContent.vue?vue&type=style&index=0&id=b33542da&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33542da",
  null
  
)

export default component.exports